export default {"src":"/_next/static/media/close-icon-hover.988a8cef.svg","height":40,"width":40};